// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__CRxhg","textarea_container":"Textarea_textarea_container__JEg89"};